<div class="account-menu" *ngIf="isLoggedIn" (click)="$event.stopPropagation()">
  <button class="account-trigger" type="button" (click)="toggleMenu($event)">
    <img
      *ngIf="profileImageUrl; else fallbackAvatar"
      class="account-trigger__image"
      [src]="profileImageUrl"
      alt="Mi cuenta"
      (error)="onImageError()"
    />
    <ng-template #fallbackAvatar>
      <span class="account-trigger__avatar">{{ profileInitial }}</span>
    </ng-template>
  </button>

  <div class="account-dropdown" *ngIf="isMenuOpen">
    <button class="account-dropdown__item account-dropdown__item--accent" type="button" (click)="logout($event)">
      Cerrar sesión
    </button>
  </div>
</div>
